import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TextLogo } from 'components/TextLogo';

export const LogoWithTagline = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Stack spacing={1}>
      <Box
        sx={{
          textAlign: 'center',
          pt: 9,
          '& svg': { width: 261, height: 'auto' },
        }}
      >
        <TextLogo />
      </Box>

      <Typography
        align="center"
        component="h2"
        sx={(theme) => ({
          color: theme.palette.brand.contrastText,
          opacity: 0.6,
          fontWeight: 600,
        })}
      >
        {t('brand.tagline')}
      </Typography>
    </Stack>
  );
};
